import type { ServiceOfferingReadiness } from "./serviceSetupReadiness";
import { readinessBadgeLabel } from "./serviceSetupReadiness";

export function ServiceSetupReadinessBadge(props: { readiness: ServiceOfferingReadiness }) {
  const { readiness } = props;
  const label = readinessBadgeLabel(readiness);
  const tone = readiness.dispatchReady
    ? "border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-900 dark:bg-emerald-950/40 dark:text-emerald-100"
    : readiness.blockingDone > 0
      ? "border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-100"
      : "border-gray-200 bg-gray-50 text-gray-700 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300";

  return (
    <span className={`inline-flex rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${tone}`}>
      {label}
    </span>
  );
}
